import React from 'react'

/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * Internal dependencies
 */
import './style.scss';
import { __, sprintf } from 'StylistParent/i18n';
import Dashicon from 'Components/dashicon';
import IconButton from 'Components/icon-button';

class SidebarHeader extends React.Component {
	onSetPanel = () => {

	}

	onSidebarTabChange = ( newId ) => {
		this.props.onSidebarTabChange( newId )
	}

	render() {
		const { sidebarTab } = this.props
		const closeSidebar = () => onToggleSidebar( undefined, false );

		return (
			<div className="components-panel__header edit-post-sidebar__panel-tabs">
				<button
					onClick={ () => {
						this.onSidebarTabChange( 'styling' )
					} }
					className={ `edit-post-sidebar__panel-tab ${ sidebarTab === 'styling' ? 'is-active' : '' }` }
					aria-label={ __( 'Document settings' ) }
				>
					{ __( 'Styling' ) }
				</button>
				<button
					onClick={ () => {
						this.onSidebarTabChange( 'code' )
					} }
					className={ `edit-post-sidebar__panel-tab ${ sidebarTab === 'code' ? 'is-active' : '' }` }
					aria-label={ __( 'Block settings' ) }
				>
					{ __( 'Code' ) }
				</button>
				{/* <IconButton
					onClick={ closeSidebar }
					icon="admin-post"
					label={ __( 'Pin Sidebar' ) }
				/> */}
			</div>
		)
	}
}

export default SidebarHeader;



// WEBPACK FOOTER //
// ./dev/stylist_parent/components/sidebar-header/index.js